export default __webpack_public_path__ + "static/media/anu-logo.0373e21a.png";